import React from 'react';

export default function TimeSlotWrapper({ children, value, resource, timeSlotHeight, calendar, isSlotAvailable }) {
    const slotAvailable = isSlotAvailable(value, resource);
    const shouldGraySlot = calendar?.grayOutClosedHours && !slotAvailable;

    return (
        <div
            className="time-slot-wrapper"
            style={{
                height: timeSlotHeight,
                backgroundColor: shouldGraySlot ? '#c4c4c4' : '#ffffff',
            }}
        >
            {children}
        </div>
    );
}
